import { type AlertVariant } from '@hivewatch/dark'

import { ProductMessageType } from '@/graphql/generated/schemas'

/**
 * Maps a saved announcement type onto the variant name Dark's `Alert` takes. Falls back to Info
 */
export const pmtToAlertString = (
  productMessageType: ProductMessageType
): AlertVariant => {
  switch (productMessageType) {
    case ProductMessageType.Info:
      return 'info'
    case ProductMessageType.Success:
      return 'success'
    case ProductMessageType.Warning:
      return 'warning'
    case ProductMessageType.Error:
      return 'error'
    // The value comes from the backend at runtime, so it can be null or a
    // ProductMessageType this build doesn't know about yet
    default:
      return 'info'
  }
}
